<template>
  <modal
    id="video-player-modal"
    v-model="modalVisible"
    :header="false"
    :footer="false"
    :header-close-button="false"
    @closed="onClose"
  >
    <button id="close" slot="before-content" @click.prevent="onClose">
      <i class="af-icons af-icons-cross"></i>
    </button>
    <video
      :id="videoId"
      :poster="poster"
      class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9"
      crossorigin="anonymous"
    >
      <source :src="source" type="application/x-mpegURL" />
      <track
        v-if="caption"
        kind="captions"
        :src="caption.source"
        label="Captions"
        default
      />
    </video>
  </modal>
</template>

<script>
import { Modal } from 'vue-bootstrap';
import options from '../../video-options';
import init from '../../video-init';

export default {
  components: {
    Modal
  },
  props: {
    fileId: {
      type: [String, Number],
      required: true
    },
    source: {
      type: String,
      required: true
    },
    poster: {
      type: String,
      default: ''
    },
    modalVisible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      player: null,
      isPlaying: false
    };
  },
  computed: {
    videoId() {
      return 'modal-video-' + this.fileId;
    }
  },
  watch: {
    modalVisible(visible) {
      // Since the video is displayed inside a modal there's no need to initialise
      // the video player in a lifecycle hook (mounted). Defer initialisation until
      // the modal becomes visible.
      if (visible && !this.player) {
        this.player = init(this.videoId, options);

        this.player.on(['waiting', 'pause'], () => (this.isPlaying = false));
        this.player.on('playing', () => (this.isPlaying = true));
      }
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    onClose() {
      // Pausing a video which is loading can have negative consequences (DOMException).
      // If the video is already playing pause immediately, otherwise bind to the
      // 'playing' event and pause when the player is ready.
      if (this.isPlaying) {
        this.player.pause();
      } else {
        this.player.one('playing', () => this.player.pause());
      }

      this.$emit('closed');
    }
  }
};
</script>
